import React, { Component } from 'react';
import moment from 'moment';
import FormError from 'components/FormError';
import { transformErrorResponse } from 'helpers/errors';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import { YEAR_DATE_FORMAT } from '../../constants';

const getMinDate = () => {
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 1);

  return moment(minDate).format(YEAR_DATE_FORMAT);
};

class SetPurchaseDueDate extends Component {
  state = {
    isOpenModal: false,
    error: false,
    date:
      this.props.purchase && this.props.purchase.due_date
        ? moment(new Date(this.props.purchase.due_date)).format(
            YEAR_DATE_FORMAT,
          )
        : '',
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.purchase.due_date !== this.props.purchase.due_date &&
      this.props.purchase.due_date
    ) {
      this.setState({
        date: moment(new Date(this.props.purchase.due_date)).format(
          YEAR_DATE_FORMAT,
        ),
      });
    }
  }

  openModal = () => {
    this.setState({ isOpenModal: true });
  };

  closeModal = () => {
    this.setState({
      isOpenModal: false,
      error: false,
      date:
        this.props.purchase && this.props.purchase.due_date
          ? moment(new Date(this.props.purchase.due_date)).format(
              YEAR_DATE_FORMAT,
            )
          : '',
    });
  };

  handleChangeDate = (e) => {
    this.setState({
      date: moment(new Date(e.target.value)).format(YEAR_DATE_FORMAT),
    });
  };

  handleUpdateDueDate = async (event) => {
    const { purchase, setPurchaseDueDate } = this.props;
    const { date } = this.state;
    if (!date || date === 'Invalid date') {
      this.setState({ error: { message: 'Due date is required.' } });
      return;
    }

    this.setState({ error: null });

    try {
      await setPurchaseDueDate(purchase.id, { due_date: date });
      this.closeModal();
    } catch (err) {
      let rootError =
        err.errors && err.errors._error ? err.errors._error : err.errors;
      if (rootError.due_date && rootError.due_date[0]) {
        rootError.due_date = rootError.due_date[0];
      }
      this.setState({ error: transformErrorResponse(rootError) });
    }
  };

  render() {
    const { isOpenModal, date, error } = this.state;

    return (
      <React.Fragment>
        <button className="btn btn-default" onClick={this.openModal}>
          Set Due Date
        </button>
        <ConfirmModal
          className="due-date-modal"
          isOpen={isOpenModal}
          title="Set Due Date"
          description={
            <>
              Please select the due date.
              <br />
              <br />
              <div className="form-group">
                <label className="control-label">Due Date</label>
                <input
                  className="form-control"
                  type="date"
                  value={date}
                  min={getMinDate()}
                  onChange={this.handleChangeDate}
                />
              </div>
              {error && <FormError error={error} />}
            </>
          }
          onClose={this.closeModal}
          onConfirm={this.handleUpdateDueDate}
          closeOnConfirmClick={false}
        />
      </React.Fragment>
    );
  }
}

export default SetPurchaseDueDate;
